<template>
	<div class="shujuku" style="width: 1400px;background: #FFFFFF;margin: 20px auto;padding: 30px 40px;">
		<div class="u-flex u-col-center u-row-between" style="margin-bottom: 26px;">
			<el-dropdown placement="bottom">
				<div class="u-flex u-col-center u-row-center" style="width: 160px;height: 44px;border: 1px solid #DDDDDD;">
					<img style="width: 20px;height: 20px;margin-right: 10px;" src="../../assets/index1-3.png" alt="">
					<span style="font-size: 22px;color: #222222;margin-right: 8px;">宏观数据</span>
					<i class="el-icon-caret-bottom"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item>宏观数据</el-dropdown-item>
					<el-dropdown-item>医疗数据</el-dropdown-item>
					<el-dropdown-item>海关数据</el-dropdown-item>
					<el-dropdown-item>企业数据</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-input placeholder="输入关键字，例如GDP" style="width: 540px;" v-model="keyword">
				<div slot="prepend" class="lianji" style="height: 100%;background: #F7F7F7;border-radius: 4px 0px 0px 4px;width: 150px;">
					<el-cascader placeholder="选择行政区划"  v-model="value" :options="options" :props="props" @change="handleChange"></el-cascader>
				</div>
				<div @click="getdata()" slot="suffix" class="u-flex u-col-center u-row-center" style="width: 118px;height: 100%;background: #51BA85;border-radius: 0px 4px 4px 0px;color: #fff;font-size: 20px;">
					<i class="el-icon-search" style="margin-right: 5px;"></i>
					<span>搜索</span>
				</div>
			</el-input>
			<!-- <el-radio-group v-model="tabPosition" @change="change">
				<el-radio-button label="1">
					<i class="el-icon-data-board"></i>
					<span>数据表格</span>
				</el-radio-button>
				<el-radio-button label="2">
					<i class="el-icon-data-line"></i>
					<span>图表趋势</span>
				</el-radio-button>
			</el-radio-group> -->
		</div>
		<div v-if="tabPosition == 1">
			<el-table :data="tableData" style="width: 100%;background-color: #F6F6F6;">
				
				<el-table-column type="selection" width="50"></el-table-column>
				<el-table-column type="index"   width="50"></el-table-column>
				<el-table-column prop="A1" label="指数名称"></el-table-column>
				<el-table-column prop="H9" label="频率"></el-table-column>
				<el-table-column prop="H10" label="起始时间"></el-table-column>
				<el-table-column prop="H11" label="结束时间"></el-table-column>
				<el-table-column fixed="right" label="操作">
					<template slot-scope="scope">
						<div class="u-flex u-col-center u-row-between" style="height: 30px;width: 100px;">
							<span style="width: 42px;line-height: 20px;border-radius: 2px;border: 1px solid #51BA85;font-size: 16px;color: #51BA85;text-align: center;" @click="tiqu(scope.row)">提取</span>
							<span style="width: 42px;line-height: 20px;border-radius: 2px;border: 1px solid #FF1C1C;font-size: 16px;color: #FF1C1C;text-align: center;" @click="del(scope)">移除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-flex u-col-center u-row-between" style="padding: 28px 0;">
				<el-button type="primary" @click="tiquall">提取数据</el-button>
				<!-- <el-button type="primary" plain icon="el-icon-upload2">导出下表表格</el-button> -->
				<!-- <el-button type="defaule">默认布局<i class="el-icon-caret-bottom"></i></el-button> -->
				<div style="width: 600px;"></div>
				<el-button type="primary" @click="daochu">导出以下数据</el-button>
			</div>
			<el-table :data="tableData1" style="width: 100%;background-color: #F6F6F6;" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50"></el-table-column>
				<el-table-column type="index"   width="50"></el-table-column>
				<el-table-column prop="A1" label="指数名称"></el-table-column>
				<el-table-column prop="H9" label="频率"></el-table-column>

				<el-table-column prop="H10" sortable label="起始时间"></el-table-column>
				<el-table-column prop="H11" sortable label="结束时间"></el-table-column>
				<el-table-column prop="H12" sortable label="指数结果"></el-table-column>

				<el-table-column prop="B20" label="省"></el-table-column>
				<el-table-column prop="C1" label="市"></el-table-column>
				<el-table-column prop="C2" label="区"></el-table-column>
				
			</el-table>
		</div>
		<div v-if="tabPosition == 2" id="zhexian" style="height: 700px;"></div>
		<el-dialog :visible.sync="dialogVisible" width="900px;">
			<div>
				<!-- <el-input placeholder="输入关键字，例如GDP" style="width: 540px;margin-bottom: 20px;">
					<div slot="prepend" class="lianji" style="height: 100%;background: #F7F7F7;border-radius: 4px 0px 0px 4px;width: 150px;">
						<el-cascader placeholder="选择行政区划" v-model="value" :options="options" :props="props" @change="handleChange"></el-cascader>
					</div>
					<div slot="suffix" class="u-flex u-col-center u-row-center" style="width: 118px;height: 100%;background: #51BA85;border-radius: 0px 4px 4px 0px;color: #fff;font-size: 20px;">
						<i class="el-icon-search" style="margin-right: 5px;"></i>
						<span>搜索</span>
					</div>
				</el-input>
				<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
					<el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
				</el-checkbox-group> -->
				<el-table :data="tableData2" style="width: 100%;background-color: #F6F6F6;">
					<!-- <el-table-column type="selection" width="50"></el-table-column> -->
					<el-table-column type="index"   width="50"></el-table-column>
				<el-table-column prop="A1" label="指数名称"></el-table-column>
				<el-table-column prop="H9" label="频率"></el-table-column>
				<el-table-column prop="H10" label="起始时间"></el-table-column>
				<el-table-column prop="H11" label="结束时间"></el-table-column>
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
							<div class="u-flex u-col-center u-row-between" style="height: 30px;width: 100px;">
								<span style="width: 42px;line-height: 20px;border-radius: 2px;border: 1px solid #1C6AFF;font-size: 16px;color: #1C6AFF;text-align: center;" @click="addtable(scope.row)">添加</span>
								<!-- <span style="width: 42px;line-height: 20px;border-radius: 2px;border: 1px solid #51BA85;font-size: 16px;color: #51BA85;text-align: center;">提取</span> -->
							</div>
						</template>
					</el-table-column>
				</el-table>
				<!-- <div style="padding-top: 20px;" class="u-flex u-row-right">
					<el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
				</div> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	export default {
		data() {
			return {
				value: [],
				options: [],
				props: {
					label: 'name',
					value: 'name',
					checkStrictly: true
				},
				checkedCities: [],
				cities: ['A', 'B', 'C'],
				tabPosition: "1",
				tableData2: [],
				tableData1: [],
				tableData: [],
				dialogVisible: false,
				sheng: '',
				shi: '',
				qu: '',
				keyword: '',
				checktable: [],
				userdata:{}
			}
		},
		created() {
			this.getcity()
			this.getuser()
		},
		methods: {
			getuser(){
				this.$http({
					url: '/api/Login/getUserInfo'
				}).then(res => {
					if(res.code == 1){
						this.userdata = res.data
					}
				})
			},
			addtable(item){
				this.tableData.push(item)
			},
			daochu() {
				if (this.checktable.length > 0) {
					var arr = []
					this.checktable.forEach(val => {
						arr.push(val.id)
					})
					window.open(this.$url + '/api/Bigdata/export?ids=' + arr.join(","))
				} else {
					this.$message.error("请选择数据")
				}
			},
			handleSelectionChange(e) {
				this.checktable = e
			},
			tiquall() {
				if(this.userdata.vip_level == 0){
					this.$message.error("请升级会员")
					return
				}
				this.tableData1 = this.tableData
			},
			del(e) {
				this.tableData.splice(e.$index, 1)
			},
			getcity() {
				this.$http({
					url: '/api/Bigdata/sheng'
				}).then(res => {
					if (res.code == 1) {
						// this.options = res.data
						this.options=[{id:0,name:"全部",pid:0,shortname:"全部"},...res.data];
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			tiqu(item) {
				if(this.userdata.vip_level == 0){
					this.$message.error("请升级会员")
					return
				}
				this.tableData1.push(item)
			},
			getdata() {
				this.$http({
					url: '/api/Bigdata/macroscopic',
					data: {
						sheng: this.sheng,
						shi: this.shi,
						qu: this.qu,
						name: this.keyword
					}
				}).then(res => {
					if (res.code == 1) {
						this.tableData2 = res.data
						this.dialogVisible = true
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			handleChange(e) {
				this.sheng = e[0]=='全部'?'':e[0]
				this.shi = e[1]
				this.qu = e[2]
			},
			handleCheckedCitiesChange() {

			},
			change(e) {
				if (e == 2) {
					var chartDom = document.getElementById('zhexian');
					var myChart = echarts.init(chartDom);
					myChart.setOption({
						// legend: {},
						xAxis: {
							type: 'category',
							data: ['2018', '2019', '2020', '2021', '2022', '2023', '2024'],
							show: false
						},
						yAxis: {
							type: 'value',
						},
						tooltip: {
							trigger: 'axis',
							position: function(pt) {
								return [pt[0], '10%'];
							}
						},
						toolbox: {
							feature: {
								dataZoom: {
									yAxisIndex: 'none'
								},
								restore: {},
								saveAsImage: {}
							}
						},
						dataZoom: [{
								type: 'inside',
								start: 0,
								end: 100
							},
							{
								start: 0,
								end: 10
							}
						],
						series: [{
							name: '城市超级数据库',
							type: 'line', // 设置图表类型为饼图
							// radius: '45%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
							label: {
								show: false
							},
							// lineStyle:{
							// 	width:10
							// },
							itemStyle: {
								color: '#51BA85'
							},
							data: [820, 932, 901, 934, 1290, 1330, 1320],
							smooth: true,
						}]
					});
				}
			}
		}
	}
</script>

<style lang="scss">
	.shujuku {
		.el-input__suffix {
			right: 0;
		}

		.el-input-group__prepend {
			padding: 0;
		}

		.lianji {
			.el-cascader {
				line-height: 38px;
				height: 38px;
			}

			.el-input__inner {
				border: none;
				line-height: 38px;
				height: 38px;
				background-color: #F7F7F7;
			}
		}
	}
</style>
